
if($('#category-header').length){
    function mhfiltr() {
      $('.slider-wrapper').wrapInner('<div class="pricefilter"></div>');
      $('.slider-wrapper h4').insertBefore('.pricefilter');
      $('.filter-section h4').click(function(){
          $(this).closest('.filter-section').toggleClass('close');
      });
      $('.slider-wrapper h4').click(function(){
          $(this).closest('.slider-wrapper').toggleClass('close');
      });
      if($('.vybrane-filtry').length == 0) { 
        $('#category-header').before('<div class="vybrane-filtry"></div>'); 
      }
      $('.vybrane-filtry').html('')
      $(".filter-label.active").clone().appendTo(".vybrane-filtry");
      $('.filter-section.filter-section-count p').clone().appendTo(".vybrane-filtry")
      $(".vybrane-filtry .filter-label.active").closest("div").addClass("aktivni-filtr"); 
      $(".vybrane-filtry .filter-section fieldset div:not(.aktivni-filtr)").remove(); 

      var leftValue = $('#slider span').first().css('left');
      if (leftValue !== "0px" && leftValue !== "0%") {
        $(".slider-wrapper").clone().appendTo(".vybrane-filtry");
        $(".vybrane-filtry").addClass("aktivni-filtr")
      }

      }

      $(document).ready(function() { 
        mhfiltr(); 
      });  

  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhfiltr();
   
  });  

}
